import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http'

export interface Role {
  id: number;
  name: string;
  subname: string;
}

@Injectable({
  providedIn: 'root'
})


export class GRolesService {

  constructor(private http: HttpClient) { }

  GetGroupAdmin(id:string) {
    return this.http.get(environment.api_url + 'api/v1.0/groups/id/'+id+'/listadmin')
  }
  GetAllRoles() {
    return this.http.get<Role[]>(environment.api_url + 'api/v1.0/roles/status/0')
  }
  GetGroupRoles() {
    return this.http.get<Role[]>(environment.api_url + 'api/v1.0/roles/status/1')
  }
  AddGroupAdmin(id, body) {
    return this.http.post(environment.api_url + 'api/v1.0/mangroups/id/' + id +'/addadmintogroup', body )
  }

  DeleteGroupAdmin(id: string) {
    return this.http.delete(environment.api_url + 'api/v1.0/mangroups/id/' + id + '/removeadminfromgroup');
  }

  ChangeGroupRole(idUser, idRole) {
    return this.http.get(environment.api_url + 'api/v1.0/roles/update/iduser/' + idUser + '/idrole/' + idRole)
  }
}
